import { render } from "./OurYoutube.vue?vue&type=template&id=2416ec82&scoped=true"
import script from "./OurYoutube.vue?vue&type=script&lang=js"
export * from "./OurYoutube.vue?vue&type=script&lang=js"

import "./OurYoutube.vue?vue&type=style&index=0&id=2416ec82&scoped=true&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2416ec82"]])

export default __exports__